module.exports = __webpack_public_path__ + "static/media/29ADMSPC21.8243f893.jpg";